module.exports = __webpack_public_path__ + "static/media/AVE.1bc7faed.png";